export default __webpack_public_path__ + "img/pieMCsiL.fc0aed11.svg";